import React, { useEffect, useMemo, useState } from "react";
import { Aviation, Expeditor, File, MapsData, Order, User } from "../../../services";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import CustomButton from "../../../components/custom/custom-button/CustomButton";
import { requestErrorDisplay } from "../../../utils";
import OrdersCreateAviationView from "../../../components/orders/views/OrdersCreateAviationView";
import { t } from "i18next";
import AviaOrdersParsingData from "../utils/AviaOrderParsingData";
import { useLanguage } from "../../../context/LanguageContext";
import { getCitiesRefreshTargets } from "../utils/cityRefresh";

import { buildAviationOrderPayload } from "../utils/aviationOrderPayload";
import useAviationAssignment from "../utils/useAviationAssignment";

const OrdersAviationCopyPage = () => {
  const location = useLocation();
  const params = useParams();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(true);
  const [isEditOrder, setEditOrder] = useState(
    location.pathname === `/aviation/edit/${orderId}`,
  );

  const [countries, setCountries] = useState([]);
  const [partners, setPartners] = useState([]);
  const [orderData, setOrderData] = useState(null);
  const [aviaDetails, setAviaDetails] = useState(null);

  const [errors, setErrors] = useState({});

  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [airportFrom, setAirportFrom] = useState();
  const [airportTo, setAirportTo] = useState();
  const [airportsFrom, setAirportsFrom] = useState([]);
  const [airportsTo, setAirportsTo] = useState([]);
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderName, setSenderName] = useState("");
  const [senderPhone, setSenderPhone] = useState();
  const [categoryName, setCategoryName] = useState("");
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [details, setDetails] = useState();
  const [copyCount, setCopyCount] = useState(1);
  const [price, setPrice] = useState(0);
  const [netPrice, setNetPrice] = useState();
  const [distance, setDistance] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState("");
  const assignment = useAviationAssignment(orderData);
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");
  const [currency, setCurrency] = useState(null);
  const [acceptedCurrency, setAcceptedCurrency] = useState(null);

  const [citiesRefreshCountryId, setCitiesRefreshCountryId] = useState(null);
  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  const [files, setFiles] = useState([]);
  const [fileInvoice, setInvoiceFile] = useState(null);

  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  useEffect(() => {
    if (!isEditOrder || !orderData?.expeditorId) return;
    setPartner(partners.find((item) => item.expeditorCompanyId === orderData.expeditorId) || {
      id: orderData.expeditorId,
      expeditorCompanyId: orderData.expeditorId,
      name: orderData.expeditorName || orderData.expeditorId,
    });
  }, [isEditOrder, orderData, partners]);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo]);

  useEffect(() => {
    if (cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if (user && user.id) {
        await Order.getCountries(currentLanguage)
          .then(async (response) => {
            setCountries(response.data);

            if (orderId) {
              await AviaOrdersParsingData(orderId, currentLanguage,{
                setLoadingGet,
                setOrderData,
                setAviaDetails,
                setPartnersForTender: isEditOrder ? setPartnersForTender : undefined,
                partners,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error);
          });
      } else {
        console.log("Пользователь не определен");
        setCountries([]);
      }
    } catch (e) {
      toast.error("Ошибка при загрузке данных");
    } finally {
      setLoadingGet(false);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, [user, currentLanguage]);

  useEffect(() => {
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed" && partner.companyName)
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log("Список пуст");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (!countryFrom?.id) return;

    Order.getCities(currentLanguage, countryFrom.id)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
        setCitiesFrom(cities);

        if (orderData?.cityIdFrom) {
          const city = cities.find(c => c.id === orderData.cityIdFrom);
          if (city) setCityFrom(city);
        }
      })
      .catch((error) => {
        requestErrorDisplay(error);
      });
  }, [countryFrom, orderData]);

  useEffect(() => {
    if (!citiesRefreshCountryId) return;

    Order.getCities(currentLanguage, citiesRefreshCountryId)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter((city) => city.name).sort((a, b) => a.name.localeCompare(b.name));
        const targets = getCitiesRefreshTargets(citiesRefreshCountryId, countryFrom, countryTo);
        if (targets.from) setCitiesFrom(cities);
        if (targets.to) setCitiesTo(cities);
      })
      .catch((error) => requestErrorDisplay(error))
      .finally(() => setCitiesRefreshCountryId(null));
  }, [citiesRefreshCountryId]);

  useEffect(() => {
    if (!countryTo?.id) return;

    Order.getCities(currentLanguage, countryTo.id)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
        setCitiesTo(cities);

        if (orderData?.cityIdTo) {
          const city = cities.find(c => c.id === orderData.cityIdTo);
          if (city) setCityTo(city);
        }
      })
      .catch((error) => {
        requestErrorDisplay(error);
      });
  }, [countryTo, orderData]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });
    } else {
      setIsLoadingMap(false);
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  useEffect(() => {
    if (!orderData || !countries.length) return;

    const fromCountry = countries.find(c => c.id === orderData.countryIdFrom);
    if (fromCountry) setCountryFrom(fromCountry);

    setAddressFrom(orderData.addressFrom || "");
    setSenderPhone(orderData.senderPhoneNumber || "");
    setSenderName(orderData.senderName || "");

    const toCountry = countries.find(c => c.id === orderData.countryIdTo);
    if (toCountry) setCountryTo(toCountry);

    setAddressTo(orderData.addressTo || "");
    setRecipientName(orderData.recipientName || "");
    setRecipientPhone(orderData.recipientPhoneNumber || "");
    setRecipientEmail(orderData.recipientEmail || "");
    setAddressIdFrom(orderData?.addressId || "")

    setWeight(orderData.weight ?? "");
    setVolume(orderData.volume ?? "");

    setCategoryName(orderData.categoryName || "");

    setDetails(orderData.details || "");
    setCurrency(isEditOrder ? orderData.acceptedCurrency : null);
    setAcceptedCurrency(isEditOrder ? orderData.acceptedCurrency || orderData.currency || null : null);
    setDistance(orderData.distance ?? 0);

    if (!isEditOrder) return;

    setPrice(orderData.price ?? 0);
    setPickUpDate(orderData.shippingDate ? new Date(orderData.shippingDate) : null);
    setDeliveryDate(orderData.unloadingDate ? new Date(orderData.unloadingDate) : null);
    setTenderDateEnd(orderData.tenderDateEnd ? new Date(orderData.tenderDateEnd) : null);
    setTenderEndTime(orderData.tenderDateEnd ? new Date(orderData.tenderDateEnd) : null);
    const time = (hour) => hour == null ? null : new Date(new Date().setHours(hour, 0, 0, 0));
    setPickUpStartTime(time(orderData.shippingHourFrom));
    setPickUpEndTime(time(orderData.shippingHourTo));
    setDeliveryStartTime(time(orderData.unloadingHourFrom));
    setDeliveryEndTime(time(orderData.unloadingHourTo));
  }, [orderData, countries, isEditOrder]);

  const formData = () =>
    buildAviationOrderPayload(
      {
        ...(isEditOrder ? { orderId } : {}),
        userId: user.id,
        type: 0,
        isPublic: true,
        price,
        netPrice: 0,
        countryIdFrom: countryFrom?.id,
        cityIdFrom: cityFrom?.id,
        addressFrom: addressFrom,
        addressId: addressIdFrom,
        shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
        shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
        shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
        countryIdTo: countryTo?.id,
        cityIdTo: cityTo?.id,
        addressTo: addressTo,
        unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
        unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
        unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
        details: details || t("ordersCreateDesktop.detailsSection.noDescription"),
        weight: weight ? String(weight).replace(",", ".") : null,
        volume: volume ? String(volume).replace(",", ".") : null,
        categoryName: categoryName,
        copyCount: copyCount,
        distance: distance || 0,
        recipientName: recipientName,
        recipientEmail: recipientEmail,
        recipientPhoneNumber: recipientPhone,
        currency: acceptedCurrency,
        acceptedCurrency: acceptedCurrency,
      },
      {
        ...assignment,
        partner,
        partnersForTender,
        tenderDateEnd,
        tenderEndTime,
        price,
        currency,
        acceptedCurrency,
      },
    );

  const createOrder = () => {
    const data = formData();

    setLoadingCreate(true);

    const request = isEditOrder
      ? Aviation.update(orderId, data)
      : Aviation.createOrder(data);

    request
      .then((res) => res.data)
      .then((response) => {
        const newOrderId = isEditOrder ? orderId : response[0]?.id;

        if (files.length) {
          const uploadPromises = files.map(f => uploadFile(newOrderId, f, 6));

          Promise.all(uploadPromises)
            .finally(() => {
              setLoadingCreate(false);
            });
        } else {
          setLoadingCreate(false);
        }

        toast.success(isEditOrder
          ? t('ordersCopy.toast.orderEdited')
          : t('ordersCreate.toast.orderCreated'));

        navigate(`/aviation/list`);
      })
      .catch((error) => {
        console.log(error);
        setLoadingCreate(false);
        requestErrorDisplay(error, "Произошла ошибка, попробуйте позже");
      })
  };

  const uploadFile = (orderId, file, type = 6) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData)
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'ordersCreate.errors.uploadFileError');
        return Promise.reject(error);
      });
  };

  const queryInsurance = () => {
    if (insurance) {
      setInsurance(false);
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    } else {
      setInsurance(true);
    }
  };

  const calcInsurance = (val) => {
    setDeclaredPrice(val);
    if (+val) setInsurancePrice(Math.trunc((+val / 100) * 0.3));
    else setInsurancePrice(null);
  };

  if (isLoadingGet) {
    return <Loading inBlock />;
  }

  if (!orderData) {
    return (
      <div role="alert">
        <p>{t("unifiedOrder.loadError")}</p>
        <CustomButton text={t("authSession.retry")} onClick={getDefaultData} />
      </div>
    );
  }

  if (
    isEditOrder &&
    orderData &&
    user?.companyId !== orderData.companyId &&
    orderData?.status !== "awaitingoffer"
  ) {
    return (
      <div className="alert alert-warning text-center" role="alert">
        <strong>{t('common.warning')}</strong> {t('ordersCopy.errors.editNotAllowed')}
      </div>
    );
  }

  const getPropsData = () => ({
    recipientPhone,
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    airportFrom,
    airportTo,
    setAirportFrom,
    setAirportTo,
    airportsFrom,
    airportsTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    categoryName,
    setCategoryName,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    calcInsurance,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    distance,
    price,
    netPrice,
    insurancePrice,
    createLoading,
    copyCount,
    setCopyCount,
    createOrder,
    updatePrice,
    setIsСallСities: setCitiesRefreshCountryId,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    ...assignment,
    tenderDateEnd,
    tenderEndTime,
    setTenderDateEnd,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    senderName,
    setSenderName,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
    acceptedCurrency,
    setAcceptedCurrency,
    currency,
    setCurrency,
  });

  return (
    <>
      <OrdersCreateAviationView
        {...getPropsData()}
        onPriceChange={setPrice}
        errors={errors}
        setErrors={setErrors}
        isCopy={!isEditOrder}
        isEdit={isEditOrder}
        headTitle={isEditOrder ? t('ordersCopy.title.edit') : t('ordersCopy.title.copy')}
      />
    </>
  );
};

export default OrdersAviationCopyPage;
